import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {GetAppTwoTone} from "@material-ui/icons";
import Link from "@material-ui/core/Link";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

function createData(id, description, downloadLink) {
    return { id, description, downloadLink };
}

const rows = [
    createData("envPolicy", "Environmental Policy", "/policies/Environmental_Policy_Rev_1.docx"),
    createData("harassPolicy", "Harassment Policy", "/policies/Harassment_Policy_Rev_1.docx"),
    createData("ohsmsPolicy", "OHSMS Policy", "/policies/OHSMS_Policy_Rev_1.docx"),
    createData("qualityPolicy", "Quality Policy", "/policies/QUALITY_Policy_Rev_1.docx"),

];

class Policies extends Component {
    render() {
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        return <div>
            <Typography component="h2" variant="h5">
                POLICIES
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                <Table className={classes.table} aria-label="simple table">
                    <TableBody>
                        {rows.map(row => (
                            <TableRow key={row.id}>
                                <TableCell component="th" scope="row">{row.description}</TableCell>
                                <TableCell>{!isDemo && row.downloadLink && <Link href={row.downloadLink} download><GetAppTwoTone/></Link>}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </div>;
    }
}

export default withStyles(classes)(Policies);